export const responsive = {
    largeDesktop: {
      breakpoint: { max: 1920, min: 1441 },
      items: 3,
    },
    desktop: {
      breakpoint: { max: 1440, min: 1280 },
      items: 3,
    },
    smallDesktop: {
      breakpoint: { max: 1279, min: 1025 },
      items: 2,
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 767, min: 0 },
      items: 1,
    },
  };